import { BsTwitter } from 'react-icons/bs';
import { FaTelegramPlane } from 'react-icons/fa';
import { SiDiscord, SiGitbook } from 'react-icons/si';

export const social = [
  {
    icon: SiDiscord,
    label: 'Discord',
    link: 'https://discord.com/'
  },
  {
    icon: FaTelegramPlane,
    label: 'Telegram',
    link: 'https://web.telegram.org'
  },
  {
    icon: BsTwitter,
    label: 'Twitter',
    link: 'https://twitter.com/'
  },
  {
    icon: SiGitbook,
    label: 'Gitbook',
    link: 'https://www.gitbook.com/'
  }
];
